import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationComponent } from './location/location.component';
import { DlsIconModule } from '@zelis/dls/icons';
import { DlsHighlightModule } from '@zelis/dls/highlight';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [CommonModule, DlsIconModule, DlsHighlightModule, MatTooltipModule],
  declarations: [LocationComponent],
  exports: [LocationComponent],
})
export class DlsLocationModule {}
